import styled from "styled-components";

export const InputBuscadorContainer = styled.div`
  .input {
    position: relative;
    width: 628px;
    height: 48px;
    border-radius: 4px;
    border: 1px solid var(--color-grey65);
    background: var(--color-grey95);
    font-size: 28px;
    color: var(--color-latex30);
    padding: 8px;
    overflow: hidden;
    display: flex; /* Asegúrate de que el contenido sea un flex container */
    align-items: center; /* Alinea el contenido verticalmente al centro */
  }

  .cursor {
    width: 2px;
    height: 100%;
    background-color: var(--color-latex30);
    animation: parpadeo 1s step-end infinite;
  }

  @keyframes parpadeo {
    from,
    to {
      background-color: transparent;
    }
    50% {
      background-color: var(--color-latex30);
    }
  }
`;

export const InputBuscadorBody = styled.div``;
export const InputBuscadorFooter = styled.div``;
